export class ColumnTypes {
    static column_type_hidden: string = 'hidden';
    static column_type_date: string = 'date';
    static column_type_actions: string = 'actions';
    static column_type_control: string = 'control';
    static column_type_checkbox: string = 'checkbox';
}